<template>
	<c-dialog ref="dialog" title="送修记录详情" mode="slide" width="600" enable-flex mask-close :button="false">
		<c-title>送修信息</c-title>
		<c-detail class="m-detail-table" column="1" style="padding-top: 0;">
			<c-detail-item label="背贴码">{{delivery.produce_unique_code || '-'}}</c-detail-item>
			<c-detail-item label="型号">{{delivery.model_name || '-'}}</c-detail-item>
			<c-detail-item label="IMEI">{{delivery.produce_imei || '-'}}</c-detail-item>
			<c-detail-item label="维修单位">{{delivery.repair_unit || '-'}}</c-detail-item>
			<c-detail-item label="送修人">{{delivery.sender_user_name || '-'}}</c-detail-item>
			<c-detail-item label="维修金额">
				<span style="color: #FF6900;">￥{{totalAmount}}</span>
			</c-detail-item>
			<c-detail-item label="状态">
				<c-state tag dict="deliveryRepairStateDic" :value="delivery.delivery_state"></c-state>
			</c-detail-item>
			<c-detail-item label="送修时间">{{delivery.delivery_date || '-'}}</c-detail-item>
			<c-detail-item v-if="delivery.delivery_state == 2" label="送修完成时间">{{delivery.complete_date || '-'}}</c-detail-item>
			<c-detail-item v-if="delivery.delivery_state == 2" label="送修时长">{{duration}}</c-detail-item>
			<c-detail-item label="备注">{{delivery.remark || '-'}}</c-detail-item>
		</c-detail>

		<template v-if="delivery.delivery_state == 2">
			<c-title>维修项目</c-title>
			<c-detail class="m-detail-table" column="1" style="padding-top: 0;">
				<c-detail-item v-for="(item, i) in detailList" :key="i" :label="getItemName(item.repair_item)">
					￥{{item.repair_amount}} {{ item.remark? ('(' + item.remark + ')') : '' }}
				</c-detail-item>
			</c-detail>
		</template>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
	name: 'repairDeliveryDetailDialog',

	data() {
		return {
			delivery: {},
			detailList: [],
			/*维修项字典，明细表只存 repair_item 代码，label 要显示名称*/
			itemOptions: []
		}
	},

	computed: {
		...mapState(['deliveryRepairStateDic']),

		// 明细金额合计，含负数冲减项
		totalAmount() {
			return this.detailList.reduce((sum, item) => sum + Number(item.repair_amount || 0), 0).toFixed(2);
		},

		// 送修时长：从送修时间算到完成时间
		duration() {
			if (!this.delivery.delivery_date) return '-';
			var end = this.delivery.complete_date ? new Date(this.delivery.complete_date) : new Date();
			var days = Math.ceil((end - new Date(this.delivery.delivery_date)) / (1000 * 60 * 60 * 24));
			return (days < 0 ? 0 : days) + '天';
		}
	},

	methods: {
		/*********打开弹框**********/
		open(data) {
			this.delivery = {};
			this.detailList = [];
			this.loadItemOptions();
			this.$refs.dialog.open();

			this.request({
				url: '/repair/delivery/detail',
				data: {id: data.id},
				loading: true,
				success: (result) => {
					this.delivery = result.delivery || {};
					this.detailList = result.details || [];
				}
			});
		},

		/*********加载维修项字典**********/
		loadItemOptions() {
			if (this.itemOptions.length) return;
			this.request({
				url: '/system/dic/options',
				data: {dic_type_code: 'REPAIR_ITEM'},
				success: (data) => {
					this.itemOptions = data || [];
				}
			});
		},

		/*********维修项名称**********/
		getItemName(item) {
			var matched = this.itemOptions.find(option => option.value == item);
			return matched ? matched.name : '-';
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
